import React from 'react'
import { LYSCol, LYSContainer, LYSRow } from '@core/components/Primitives'
import style from './index.module.less'

interface Props {
  leftPart?: React.ReactNode
  rightPart?: React.ReactNode
}

const SecondaryBar: React.FC<Props> = ({ leftPart, rightPart }) => {
  if (!leftPart && !rightPart) return null

  return (
    <LYSRow justify={'space-between'} align={'middle'} className={style.bar}>
      <LYSContainer className={style.container}>
        <LYSCol fill={true} className={style.leftPart}>
          {leftPart}
        </LYSCol>
        <LYSCol>{rightPart}</LYSCol>
      </LYSContainer>
    </LYSRow>
  )
}

export default SecondaryBar
